export default {
    USER_ID: 'user_G7krKDB2hznVUhAnFuqWA',
    TEMPLATE_ID: 'template_7avlafu',
    SERVICE_ID: 'service_t6fd6da'
}
